import React from 'react';

export default React.createContext({
  keyboardVisible: false,
  keyboardInsetPx: 0,
});
